import { HOW_IT_WORKS_CARDS, OFFER_CARDS } from '~/utils/features.js';

export default {
  title: 'How it works:',
  cards: HOW_IT_WORKS_CARDS,
  offers: OFFER_CARDS,
};
